import api from '../../apiConfig/apiConfig.js';
import { Get, Post, Put } from '../base/baseAjax';

let getEnquiry = param => {
	return Post({
		url: api.inquiry.inquirypcpage,
		bodyParam: param,
	});
};

let getInquiryDetails = param => {
	return Get({
		url: api.inquiry.inquiryDetails,
		PathParam: param,
	});
};

let inquiryTrend = param => {
	return Post({
		url: api.inquiry.inquiryTrend,
		bodyParam: param,
	});
};
let inquiryEntry = param => {
	return Post({
		url: api.inquiry.inquiryEntry,
		bodyParam: param,
	});
};
let inquiryIndustry = param => {
	return Post({
		url: api.inquiry.inquiryIndustry,
		bodyParam: param,
	});
};
let inquiryRegion = param => {
	return Post({
		url: api.inquiry.inquiryRegion,
		bodyParam: param,
	});
};
let inquiryService = param => {
	return Post({
		url: api.inquiry.inquiryService,
		bodyParam: param,
	});
};

let inquiryExport = param => {
	return Post({
		url: api.inquiry.inquiryExport,
		bodyParam: param,
		config: {
			timeout: 60000,
			responseType: 'blob',
		},
	});
};

let getwebsiteorder = param => {
	return Get({
		url: `${api.inquiry.getwebsiteorder}/${param}`,
	});
};
let getInquiryDetail = param => {
	return Get({
		url: api.inquiry.inquiryDetail,
		PathParam: param,
	});
};

let addInquiryLabel = param => {
	return Post({
		url: api.inquiry.addInquiryLabel,
		bodyParam: param,
	});
};

let checkInquiry = param => Post({ url: `${api.inquiry.checkInquiry}`, bodyParam: param });

let cancellationFilter = param => {
	return Post({
		url: api.inquiry.cancellationFilter,
		PathParam: param,
	});
};

let reviewfail = param => {
	return Post({
		url: api.inquiry.reviewfail,
		bodyParam: param,
	});
};

let reviewadopt = param => {
	return Get({
		url: api.inquiry.reviewadopt,
		PathParam: param,
	});
};

let auditPass = param => {
	return Post({
		url: api.inquiry.auditPass,
		bodyParam: param,
	});
};

let inquiryTranslate = params => {
	return Get({
		url: api.inquiry.inquiryTranslate,
		PathParam: params,
	});
};

// 二次审核
// 获取询盘二次审核详情
let inquirySecondReview = params => {
	return Get({
		url: api.inquiry.inquirySecondReview,
		PathParam: params,
	});
};

// 询盘二次审核
let inquirySecondReviewAudit = params => {
	return Put({
		url: api.inquiry.inquirySecondReviewAudit,
		PathParam: params,
		config: {
			timeout: 60000,
		},
	});
};

// 垃圾询盘二次审核
let inquirySecondReviewGarbageAudit = params => {
	return Put({
		url: api.inquiry.inquirySecondReviewGarbageAudit,
		PathParam: params,
		config: {
			timeout: 60000,
		},
	});
};

export default {
	getEnquiry,
	inquiryTrend,
	inquiryEntry,
	inquiryIndustry,
	inquiryRegion,
	inquiryService,
	inquiryExport,
	getwebsiteorder,
	getInquiryDetail,
	checkInquiry,
	getInquiryDetails,
	addInquiryLabel,
	cancellationFilter,
	reviewfail,
	reviewadopt,
	auditPass,
	inquiryTranslate,
	inquirySecondReview,
	inquirySecondReviewAudit,
	inquirySecondReviewGarbageAudit,
};
